import React, { useEffect, useState } from 'react'
import { auth, db } from '../firebase'
import { onAuthStateChanged, signInAnonymously, signOut, signInWithPopup, FacebookAuthProvider, GithubAuthProvider, GoogleAuthProvider, TwitterAuthProvider } from 'firebase/auth'
import { ref, onValue } from 'firebase/database'

import { isUndefined } from 'lodash'

import { GA } from '../constants'
import GAEvent from '../modules/analytics-event-helper'

const AuthContext = React.createContext()

const providers = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
  TWITTER: 'TWITTER',
  GITHUB: 'GITHUB'
}

const AuthProvider = ({ children }) => {
  const [anonymous, setAnonymous] = useState()
  const [user, setUser] = useState()
  const [userScore, setUserScore] = useState()
  const [userName, setUserName] = useState()
  const [userLoading, setUserLoading] = useState(true)

  useEffect(() => {
    let loadingComplete = false

    if (anonymous) {
      // if an anonymous user is found, loading is always complete
      loadingComplete = true
    } else {
      // if not wait until calls for userScore and userName have at least finished
      loadingComplete = !isUndefined(userScore) && !isUndefined(userName)
    }

    setUserLoading(!loadingComplete)
  }, [user, userName, anonymous, userName])

  useEffect(() => {
    onAuthStateChanged(auth, authUser => {
      if (authUser) {
        if (authUser.isAnonymous === true) {
          setUser(authUser)
          setAnonymous(authUser)
        } else {
          console.log(authUser)
          setUser(authUser)
          setAnonymous(undefined)
          // attempt to get totalScore and userName if non-anonymous user
          onValue(ref(db, `userActivity/${authUser.uid}/totalScore`), (scoreSnapshot) => {
            setUserScore(scoreSnapshot.val())
          })
          onValue(ref(db, `profiles/${authUser.uid}/userName`), (profileSnapshot) => {
            setUserName(profileSnapshot.val())
          })
        }
      } else {
        signInAnonymously(auth).catch((err) => {
          console.log('anonymous login error', err)
        })
      }
    })
  }, [])

  const refreshProfile = () => {
    if (user) {
      onValue(ref(db, `profiles/${user.uid}/userName`), (profileSnapshot) => {
        setUserName(profileSnapshot.val())
      })
    }
  }

  const handleFacebookSuccess = (result) => {
    // The signed-in user info.
    const user = result.user
    setUser(user)
  }

  const handleFacebookError = () => {

  }

  const login = (providerKey = providers.FACEBOOK) => {
    GAEvent({
      category: GA.CATEGORY.LOGIN,
      action: GA.ACTION.LOGIN_FACEBOOK,
      label: 'na'
    })

    let provider

    switch (providerKey) { // TODO: this can't be right
      case providers.FACEBOOK:
        provider = new FacebookAuthProvider()
        break
      case providers.GOOGLE:
        provider = new GoogleAuthProvider()
        break
      case providers.TWITTER:
        provider = new TwitterAuthProvider()
        break
      case providers.GITHUB:
        provider = new GithubAuthProvider()
        break
      default:
    }

    signInWithPopup(auth, provider)
      .then(result => handleFacebookSuccess(result))
      .catch(error => handleFacebookError(error))
  }

  const logout = () => {
    GAEvent({
      category: GA.CATEGORY.LOGIN,
      action: GA.ACTION.LOGOUT,
      label: 'na'
    })

    signOut(auth).then(() => { setUser(null) })
  }

  return (
    <AuthContext.Provider
      value={{
        anonymous,
        user,
        userName,
        userLoading,
        userScore,
        login,
        logout,
        refreshProfile
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
const AuthConsumer = AuthContext.Consumer

export { AuthContext, AuthProvider, AuthConsumer, providers }
